<template>
	<div>
		<el-carousel :interval="4000" type="card">
			<el-carousel-item v-for="(item, index) in swiper" :key="index"><el-image :src="item" alt="" /></el-carousel-item>
		</el-carousel>
		
		<div class="split-line f-a">
			<div class="line"></div>
			<div class="mL20 bold title">明星套餐</div>
			<div class="line mL20"></div>
		</div>
		<div class="swiper-cart ">
			<el-carousel :interval="3000" type="card" height="490px" >
				<el-carousel-item v-for="(item, index) in swiper_cart">
					<div class="item column f-a " style="margin: 0 auto;"
					@click="toDetail(item)">
						<el-image :src="item.home[0]"></el-image>
						<div class="title">{{ item.title }}</div>
						<el-button type="primary"
						>查看详情</el-button>
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="split-line f-a">
			<div class="line"></div>
			<div class="mL20 bold title">套餐系列</div>
			<div class="line mL20"></div>
		</div>
		<div class="cart f-a column">
			<div class="item f-a-j pointer" v-for="(item, index) in cart_list">
				<el-image :src="item.home[0]"></el-image>
				<div class="right">
					<div class="title">{{ item.title }}</div>
					<el-button type="primary" @click.stop="toDetail(item)">即刻拥有</el-button>
				</div>
			</div>
		</div>
		<div class="split-line f-a">
			<div class="line"></div>
			<div class="mL20 bold title">精品面膜</div>
			<div class="line mL20"></div>
		</div>
		<div class="cart f-a column">
			<div class="item f-a-j pointer" v-for="(item, index) in mask_list">
				<el-image :src="item.home[0]"></el-image>
				<div class="right">
					<div class="title">{{ item.title }}</div>
					<el-button type="primary" @click.stop="toDetail(item)">即刻拥有</el-button>
				</div>
			</div>
		</div>
		<div class="split-line f-a">
			<div class="line"></div>
			<div class="mL20 bold title">卸妆大礼包</div>
			<div class="line mL20"></div>
		</div>
		<div class="cart f-a column">
			<div class="item f-a-j pointer" v-for="(item, index) in makeup_list">
				<el-image :src="item.home[0]"></el-image>
				<div class="right">
					<div class="title">{{ item.title }}</div>
					<el-button type="primary" @click.stop="toDetail(item)">即刻拥有</el-button>
				</div>
			</div>
		</div>
		<div class="split-line f-a">
			<div class="line"></div>
			<div class="mL20 bold title">皮肤系列</div>
			<div class="line mL20"></div>
		</div>
		<div class="cart f-a column">
			<div class="item f-a-j pointer" v-for="(item, index) in skin_list">
				<el-image :src="item.home[0]"></el-image>
				<div class="right">
					<div class="title">{{ item.title }}</div>
					<el-button type="primary" @click.stop="toDetail(item)">即刻拥有</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			swiper: [
				require('@/assets/image/自在畅饮保湿霜/20180815_151230_129.jpg'),
				require('@/assets/image/自在畅饮保湿乳/20180815_151146_115.jpg'),
				require('@/assets/image/精油水薰衣草/2.jpg'),
			],
			swiper_cart: [
				{
					id:'t1',
					title:'光彩立现套装',
					home:[
						require('@/assets/image/光彩立现套装/20190612_132334_018.jpg'),
					],
					
				},
				{
					id: 't4',
					title: '泉润肌如雪5件套',
					home: [require('@/assets/image/泉润肌如雪5件套/肌如初雪套装_10.jpg')]
				},
				{
					id: 't5',
					title: '三层润燥8件套',
					home: [require('@/assets/image/三层润燥8件套/20190611_173512_079.jpg')]
				}
			],
			cart_list: [
				{
					id:'t2',
					title:'硫磺套',
					home:[
						require('@/assets/image/硫磺套/硫磺温泉毛孔净化套_04.jpg'),
					],
					list:[
						require('@/assets/image/硫磺套/硫磺温泉毛孔净化套.jpg'),
						
					]
				},
			],
			mask_list:[
				{
					id:'a4',
					title:'鎏金面膜',
					home:[
						require('@/assets/image/鎏金面膜/images/鎏金面膜_02.jpg'),
					],
					
				},
				{
					id:'a2',
					title:'保湿呼吸面膜',
					home:[
						require('@/assets/image/保湿呼吸面膜/主图/20180815_151844_194.jpg'),
					],
					
				},
			],
			makeup_list:[
				{
					id:'c3',
					title:'泉润卸妆水',
					home:[
						require('@/assets/image/泉润卸妆水/20190611_113036_002.jpg'),
					],
					
				},
				{
					id:'d1',
					title:'自在畅饮洁面乳',
					home:[
						require('@/assets/image/自在畅饮洁面乳/主图/20180815_150347_067.jpg'),
					],
					
				},
			],
			skin_list:[
				{
					id:'e1',
					title:'泉润气垫BB霜',
					home:[
						require('@/assets/image/泉润气垫BB霜/主图/20180815_150119_044.jpg'),
					]
				},
				{
					id:'e3',
					title:'防晒乳',
					home:[
						require('@/assets/image/防晒乳/主图/20180815_145537_000.jpg'),
					]
					
				}
			]
		};
	},
	methods:{
		toDetail(item){
			this.$router.push({
				path:`/category/detail/${item.id}`
			})
		}
	}
};
</script>

<style lang="less" scoped>
.swiper-cart {
	margin-top: 20px;
	.item {
		width: 400px;
		height: 490px;
		// box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
		.el-image {
			width: 80%;
		}
		.title {
			height: 50px;
			line-height: 50px;
			font-weight: bold;
			font-size: 20px;
			margin-top: 10px;
		}
		.el-button {
			margin-top: 30px;
		}
	}
	
}
.cart {
	margin-top: 20px;
	.item {
		width: 90%;
		height: 500px;
		border: 1px solid rgba(0, 0, 0, 0.125);
		.el-image {
			width: 300px;
		}
		.right {
			margin-left: 10%;
			.title {
				font-size: 30px;
				font-weight: bold;
				margin-bottom: 30px;
			}
		}
	}
}
.split-line {
	margin-top: 40px;
	.line {
		flex: 1;
		border-top: 2px solid #1f80ff;
	}
	.title {
		margin: 0 20px;
		font-size: 20px;
	}
}
</style>
